<template>
  <div class="home" v-bind:class="{'navbar':isNavbarVisible}">
    <Viz :onRender="onRender" />
    <span style="position:fixed; z-index: 1000; font-size:12px; left:15px; font-family: monospace; top:5px; color:cyan;">{{(seconds).toFixed(2)}} sec</span>
  </div>

</template>

<script>

/* eslint-disable no-console*/
// @ is an alias to /src
import Viz from '@/components/Viz.vue'

import { mapGetters} from 'vuex'
export default {
  name: 'renderer',
  data() {
    return {
      rectAlpha: 0,
      seconds: 0
    }
  },
  components: {
    Viz
  },
  mounted: function() {

  },
  created: function(){

  },
  computed:{
    ...mapGetters(['facts', 'factIndex', 'loadingProgress', 'isNavbarVisible', 'fps']),
    year: {
      get() { return this.$store.state.year; },
      set(d) { this.$store.commit('setYear', d); },
    },
    playing: {
      get() { return this.$store.state.playing; },
      set(d) { this.$store.commit('setPlaying', d); },
    },
    detailedView: {
      get() { return this.$store.state.detailedView; },
      set(d) { this.$store.commit('setDetailedView', d); },
    },
    alpha: {
      get() { return this.$store.state.alpha; },
      set(d) { this.$store.commit('setAlpha', d); },
    },
    needsRender: {
      get() { return this.$store.state.needsRender; },
      set(nr) { this.$store.commit('setNeedsRender', nr); },
    },
    nightMode: {
      get() { return this.$store.state.nightMode; },
      set(f) { this.$store.commit('setNightMode', f); },
    },
    loaded: function(){
      return this.loadingProgress >=100;
    },
  },
  watch:{
    loaded: function () {
      // eslint-disable-next-line
      setTimeout(()=>{
        this.countdown = this.fps * 2 * 2 // 2 sec delay
        this.frameCount = 0;
        this.canvas = document.getElementById('canvas')
        this.rectCanvas = document.getElementById('rect-canvas')
        this.drawingCanvas = document.createElement("CANVAS");
        this.drawingCanvas.width = this.canvas.width;
        this.drawingCanvas.height = this.canvas.height;
        this.drawingCanvas.classList.add("drawing")
        document.body.appendChild(this.drawingCanvas)
        this.drawingContext = this.drawingCanvas.getContext("2d");



        // eslint-disable-next-line
        this.capturer = new CCapture( {framerate: this.fps, verbose: true, format:'png', autoSaveTime:10 } )
        this.capturer.start();

        // eslint-disable-next-line
        console.log('RENDER STARTED')
        this.alpha = 0;
        this.nightMode = false;
      },2000);


    }
  },
  methods: {
    onRender: function(){
      if(this.drawingContext){
        this.detailedView = true;
        this.drawingContext.globalAlpha = 1
        this.drawingContext.drawImage(this.canvas, 0, 0, this.drawingCanvas.width, this.drawingCanvas.height);
        this.drawingContext.globalAlpha = this.rectAlpha
        this.drawingContext.drawImage(this.rectCanvas, 0, 0, this.drawingCanvas.width, this.drawingCanvas.height);
        this.drawingContext.globalAlpha = 1
        const ratio =this.canvas.width/1920;

        this.drawingContext.fillStyle = "rgb(255, 96, 99)";
        this.drawingContext.font = Math.round(65*ratio)+'px Formular-Mono';
        this.drawingContext.fillText(this.year, 53*ratio, 132 * ratio);

        this.drawingContext.fillStyle = "rgb(255, 255, 255)";
        this.drawingContext.font = Math.round(12*ratio)+'px Formular-Mono';
        this.drawingContext.fillText("2020", 196*ratio, 186 * ratio);
        this.drawingContext.fillText("1920", 40*ratio, 186 * ratio);

        // 40 195


        this.drawingContext.strokeStyle = "#707070";
        this.drawingContext.beginPath();
        const x = 55;
        const w = 158;
        const y = w+2;
        this.drawingContext.lineWidth = 2 * ratio;
        this.drawingContext.moveTo(x*ratio, y*ratio);
        this.drawingContext.lineTo(x*ratio + w*ratio, y*ratio);

        this.drawingContext.moveTo(x*ratio, y*ratio - 3*ratio);
        this.drawingContext.lineTo(x*ratio, y*ratio + 3*ratio);

        this.drawingContext.moveTo(x*ratio + w*ratio, y*ratio - 3*ratio);
        this.drawingContext.lineTo(x*ratio + w*ratio, y*ratio + 3*ratio);
        this.drawingContext.stroke();

        this.drawingContext.strokeStyle = "rgb(255, 96, 99)";
        this.drawingContext.lineWidth = 6 * ratio;
        this.drawingContext.beginPath();
        this.drawingContext.moveTo(x*ratio, y*ratio);
        this.drawingContext.lineTo(((x-1)*ratio + this.alpha * (w+2) * ratio), y*ratio);
        this.drawingContext.stroke();

        if(this.capturer) this.capturer.capture( this.drawingCanvas );
        if(this.countdown<=0){
          this.seconds += 1.0/(2*this.fps)
          this.alpha = Math.min(1, this.frameCount/(this.fps * 2 * 100));
          if(this.factIndex>0) {
            let end_year = this.facts[this.factIndex].end_year;
            if(!end_year) end_year = this.facts[this.factIndex].year
            this.frameCount += ((end_year - this.facts[this.factIndex].year) + 1)/15;
          } else {
            let oldFC = this.frameCount;
            this.frameCount = Math.round(this.frameCount)
            if(Math.abs(oldFC - this.frameCount)>0.01){
              /* eslint-disable-next-line*/
              console.log('**************************************** ALERT ->' +Math.abs(oldFC - this.frameCount));
            }
            this.frameCount ++;
          }
        } else {
          this.countdown--;
        }

        //ANTICIPATE THE RECT
        /*let fI = 0
        const pYear = this.year+1
        for(var i=1; i<this.facts.length; i++){
          if(pYear >=  this.facts[i].year && pYear<=this.facts[i].alpha_year){
            fI = i;
            break;
          }
        }*/
        // if(this.rectAlpha==0)
        //  this.fadingIn = true;
        if(this.factIndex>0) {
          this.rectAlpha=Math.min(1, this.rectAlpha + 1.0/(this.fps * 2));
        } else {
          this.rectAlpha=Math.max(0, this.rectAlpha - 1.0/(this.fps));
        }
        this.needsRender = true;
      }
    }
  }
}
</script>
<style>
.drawing{
  position:fixed;
  left:0px;
  top:0px;
  width:100%;
}
</style>
